// extracted by mini-css-extract-plugin
export var header = "_ay-0";